var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.active) ? _c('svg', {
    class: _vm.theme.circular,
    style: (_vm.styles),
    attrs: {
      "viewBox": "25 25 50 50",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    class: _vm.theme.path,
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "5"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bd17f1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Spinner/Spinner.vue
// module id = 567
// module chunks = 0